import { render } from "./SuperAdminLogin.vue?vue&type=template&id=5ace09e0&scoped=true"
import script from "./SuperAdminLogin.vue?vue&type=script&lang=js"
export * from "./SuperAdminLogin.vue?vue&type=script&lang=js"

import "./SuperAdminLogin.vue?vue&type=style&index=0&id=5ace09e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ace09e0"]])

export default __exports__